// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import './registerServiceWorker' //for PWA features
import './plugins/vuetify'
import './common/axios_config'
import App from './App'
import router from './router'
import store from './store'
import '@/assets/css/main.css'

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')

Vue.use(require('vue-moment'))